import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CourseCatalogOverviewCategory } from 'app/library/course-catalog/models/course-catalog-overview-category.model';
import { CourseCatalogApiService } from 'app/library/course-catalog/services/course-catalog.api-service';
import { CourseCatalogService } from '../../services/course-catalog.service';
import { filter } from 'rxjs/operators';
@Component({
    selector: 'app-catalog-sidebar',
    templateUrl: './catalog-sidebar.component.html',
    styleUrl: './catalog-sidebar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogSidebarComponent {
    @Input() categories: CourseCatalogOverviewCategory[] = [];
    @Input() navigateOnClick = true;

    @Output() categorySelected = new EventEmitter<CourseCatalogOverviewCategory>();
    @Output() rootClicked = new EventEmitter<void>();

    selectedCategoryId: string | null = null;

    constructor(private _api: CourseCatalogApiService, private cdr: ChangeDetectorRef, private _router: Router, public courseCatalogService: CourseCatalogService) {}

    ngOnInit(): void {
        this.courseCatalogService.selectedCategoryId$.pipe(filter((id): id is string => !!id)).subscribe(async (id: string) => {
            this.selectedCategoryId = id;
            this.cdr.markForCheck();
        });
    }

    async toggleCategory(category: CourseCatalogOverviewCategory): Promise<void> {
        category.open = !category.open;

        if (category.open && category.hasPublishedSubCategories && !category.children.length) {
            const children = await this._api.getCatalogsOverviewSubcategories(category.id).toPromise();
            category.children = children.map((child) => ({
                ...child,
                open: false,
                children: [],
            }));
        }

        this.cdr.detectChanges();
    }

    openCategory(category: CourseCatalogOverviewCategory): void {
        this.categorySelected.emit(category);

        if (this.navigateOnClick) {
            this._router.navigate(['/catalog/category', category.id]);
        }
    }

    onRootClick(): void {
        this.selectedCategoryId = null;

        this.rootClicked.emit();
        if (this.navigateOnClick) {
            this._router.navigate(['/catalog']);
        }
    }

    isParent(category: CourseCatalogOverviewCategory): boolean {
        return this.containsCategory(category, this.selectedCategoryId);
    }

    shouldHaveBg(category: CourseCatalogOverviewCategory): boolean {
        // Outer group background only when a child is selected (expanded parent),
        // not when the leaf category itself is selected — that avoids a double highlight.
        return this.isParent(category);
    }

    containsCategory(category: CourseCatalogOverviewCategory, id: string | null): boolean {
        if (!id) return false;
        if (!category.children?.length) return false;

        for (const child of category.children) {
            if (child.id === id) return true;
            if (this.containsCategory(child, id)) return true;
        }

        return false;
    }

    trackById(index: number, item: any) {
        return item.id;
    }
}
